<div class="card">
  <div class="card-body">
    <xormon-alerting-lpar-header label="Emails"></xormon-alerting-lpar-header>
    <div id="email_wrapper">
    <xormon-alerting-email *ngIf="readyFce" [ready]="readyFce" [form]="formFce"></xormon-alerting-email>
    </div>
  </div>
</div>
